module.exports = __webpack_public_path__ + "ab67ad76fbd849c55868be3dfd8c828e.svg";